import { connect } from 'react-redux';

import { TenantPriceList } from '../../../models/Entities/TenantPriceLists/TenantPriceList';

import * as TenantPriceListsStore from '../../../redux/middleware/TenantPriceListsMiddleware';
import { PriceListInfoPanel } from './PriceListInfoPanel';

export interface IProps {
  TenantPriceList: TenantPriceList;
}

interface DispatchProps {
  SetStartValidity: typeof TenantPriceListsStore.ActionCreators.SetStartValidity;
  SetEndValidity: typeof TenantPriceListsStore.ActionCreators.SetEndValidity;
}

type Props = IProps & DispatchProps;

const TenantPriceListInfoComponentBase = (props: Props) => (
  <PriceListInfoPanel
    priceList={props.TenantPriceList}
    i18nRoot="tenantPriceListInfo"
    onConfirmStartValidity={(date) =>
      props.SetStartValidity(props.TenantPriceList.id, date)
    }
    onConfirmEndValidity={(date) =>
      props.SetEndValidity(props.TenantPriceList.id, date)
    }
  />
);

const mapDispatchToProps = {
  SetStartValidity: TenantPriceListsStore.ActionCreators.SetStartValidity,
  SetEndValidity: TenantPriceListsStore.ActionCreators.SetEndValidity
};

export const TenantPriceListInfoComponent = connect(
  null,
  mapDispatchToProps
)(TenantPriceListInfoComponentBase as any) as any;

export default TenantPriceListInfoComponent;
